module.exports = __webpack_public_path__ + "static/lampada2-50d5e91f72293adb1785657b158273da.gif";